import { authService } from "../../utils/authService";
import type { AccessDenialCode } from "./accessDenial";

/**
 * Opens another instance the way the header's switcher does: remember it, then a
 * full page load, the only thing that clears RTK Query's instance-scoped cache.
 */
export function goToInstance(instanceId: string): void {
  authService.saveInstanceId(instanceId);
  window.location.href = `${window.location.origin}/?instanceid=${encodeURIComponent(instanceId)}`;
}

/**
 * Where Try again goes, or null to reload in place (a failed check). A refused
 * instance (no assignment, or no role in any of its products) is tried again,
 * which a grant since then now opens; otherwise Home, which picks an instance
 * the user can open.
 */
export function tryAgainPath(
  code: AccessDenialCode,
  instanceId: string | null | undefined,
): string | null {
  if (code === "CHECK_FAILED") return null;
  return (code === "NO_ASSIGNMENT" || code === "NO_PRODUCT_ACCESS") && instanceId
    ? `/?instanceid=${encodeURIComponent(instanceId)}`
    : "/";
}

/**
 * The screen's Try again. Always a full page load, so a grant made since is seen
 * with nothing cached: no resolve cache, session cache or RTK cache survives it.
 * The instance remembered on this device is forgotten first, so the next load
 * doesn't land on the same refusal.
 */
export function tryAccessAgain(
  code: AccessDenialCode,
  instanceId: string | null | undefined,
): void {
  const path = tryAgainPath(code, instanceId);
  if (path === null) {
    window.location.reload();
    return;
  }
  authService.clearInstanceSelection();
  window.location.href = `${window.location.origin}${path}`;
}
